<template>
  <div class="relative">
    <div class="vx-navbar-wrapper nav-menu-wrapper">
      <vs-navbar class="vx-navbar navbar-custom navbar-skelton navbar-tabs shadow relative" :color="navbarColor">
        <ul class="menu-items flex flex-wrap mr-auto">
          <li
            v-for="(item, index) in navMenuItems"
            :key="index"
            class="menu-item"
          >
            <template v-if="item.header">
              <h-nav-menu-header :header="item" class="menu-header relative" @getActiveLinkStyle="setTabPosition">
                <vs-chip v-if="getTag(item.tag)" class="ml-2 ce-chip " :color="item.tagColor">
                  {{ getTag(item.tag) }}
                </vs-chip>
              </h-nav-menu-header>
            </template>

            <div v-else class="menu-link">
              <h-nav-menu-item
                class="relative cursor-pointer text-base"
                :to="item.slug !== 'external' ? item.url : null"
                :href="item.slug === 'external' ? item.url : null"
                :icon="item.icon"
                :target="item.target"
                :is-disabled="item.isDisabled"
                :slug="item.slug"
                :name="item.name"
                :second-menu="item.secondMenu"
                @getActiveLinkStyle="setTabPosition"
              >
                <vs-chip v-if="getTag(item.tag)" class="ml-2 ce-chip" :color="item.tagColor">
                  {{ getTag(item.tag) }}
                </vs-chip>
              </h-nav-menu-item>
            </div>
          </li>
          <li class="menu-item">
            <button
              class="menu-item__report"
              type="button"
              @click="$emit('openModal')"
            >
              <IAnalytics class="mr-2" />
              Аналитический отчет
            </button>
          </li>
        </ul>
        <div v-if="canSee" class="ml-auto flex cursor-pointer p-2" @click="$store.commit('help/POPUP_TOGGLE', true)">
          <i-question class="mr-2" />
          <p class="text-base leading-24">
            Помощь
          </p>
        </div>
        <span v-show="canSee" class="header__tab-line bg-primary-gradient" :style="tabLinePosition" />
      </vs-navbar>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { userTypes } from '@/constants';
import IAnalytics from '@/assets/svg/icons/analytics.svg';
import IQuestion from '@/assets/svg/icons/question.svg';
import { getParamFromUrl } from '@/helper';
import HNavMenuItem   from './HorizontalNavMenuItem.vue';
import HNavMenuHeader from './HorizontalNavMenuHeader.vue';

export default {
  components: {
    HNavMenuHeader,
    HNavMenuItem,
    IAnalytics,
    IQuestion,
  },
  props: {
    navMenuItems: { type: Array, required: true },
  },
  data() {
    return {
      tabLinePosition: {},
    };
  },
  computed: {
    ...mapGetters({
      userInfo: 'userInfo',
    }),
    navbarColor() {
      return this.$store.state.theme === 'dark' ? '#10163a' : '#fff';
    },
    canSee() {
      return Object.values(userTypes).includes(this.userInfo.userRole);
    },
  },
  methods: {
    setTabPosition(styleProperties) {
      this.tabLinePosition = styleProperties;
    },
    getTag(value) {
      return typeof value === 'string' ? this.$store.getters[value] : value;
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/components/horizontalNavMenu.scss";
@import "@/assets/scss/krisha/header.scss";
</style>
